import { render, staticRenderFns } from "./masterCrm.vue?vue&type=template&id=0fd9d234"
import script from "./masterCrm.vue?vue&type=script&lang=js"
export * from "./masterCrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports